module.exports = __webpack_public_path__ + "static/media/Introduction_Section_Photo.d4c30477.webp";